<template>
  <div>
    <ManageTemplate
      v-if="$route.params.view === 'create' ||
      $route.params.view === 'edit' ||
      $route.params.view === 'duplicate'"
    />
    <ListTemplates v-else-if="!$route.params.view"/>
  </div>
</template>

<script>
import ListTemplates from '@/febos/chile/approvals/components/templates/ListTemplates';
import ManageTemplate from '@/febos/chile/approvals/components/templates/ManageTemplate';

export default {
  name: 'Templates',
  components: {
    ListTemplates,
    ManageTemplate
  }
};
</script>

<style scoped>

</style>
